import { showResultPopup } from "$ACTIONS/helper";
import showMessage from "$ACTIONS/messageUtil";

const TMP_CROSS_DOMAIN_LOGIN_TOKEN_KEY = 'tmpCrossDomainLoginToken';
const TMP_CROSS_DOMAIN_LOGIN_PATH_KEY = 'tmpCrossDomainLoginPath';

const getPostMessageTargetDomain = (domainPath) => location.host.includes('localhost') ? 'http://localhost:8888' : (typeof domainPath==='string' && domainPath ? 'https://'+domainPath.split('/')[2] : '');
const getPostMessageTargetPage = (domainPath) => getPostMessageTargetDomain(domainPath) + '/th/init4domainpath/?whoisopener=' + location.protocol+'//'+location.host;

export const POSTMSG_EVENT_PREFIX = 'DomainSeq_';

export const initReceivePostMessage = (isRemove) => {
    const fn = (event) => {
        // if (event.origin !== 'http://localhost:8383') {
        //     console.warn('Origin not allowed:', event.origin);
        //     return;
        // }
        const evtType = event.data.type;
        if (evtType===POSTMSG_EVENT_PREFIX + 'LOADED') {
            const domainToken = localStorage.getItem(TMP_CROSS_DOMAIN_LOGIN_TOKEN_KEY);
            const domainPath = localStorage.getItem(TMP_CROSS_DOMAIN_LOGIN_PATH_KEY);
            if (domainToken) {
                window.winForDomainSeg
                    .postMessage({type:POSTMSG_EVENT_PREFIX+'SEND_DOMAIN_TOKEN', domainToken}, getPostMessageTargetDomain(domainPath));
                localStorage.removeItem(TMP_CROSS_DOMAIN_LOGIN_TOKEN_KEY);
                localStorage.removeItem(TMP_CROSS_DOMAIN_LOGIN_PATH_KEY);
            }
        } else if (evtType===POSTMSG_EVENT_PREFIX + 'REDIRECT') {
            location.href = event.data.go2;
        }
    };
    window[isRemove ? 'removeEventListener' : 'addEventListener']('message', fn);
};

const openNewWindow = (crossDomainLoginToken, domainPath) => {
    showResultPopup({
        type: "info",
        title: "แจ้งเตือน", // "温馨提醒", // "Lưu Ý",
        content: "เปิดใช้งานด้วยเบราว์เซอร์", // "将为您打开新的窗口", // "Trang này sẽ được mở bằng trình duyệt",
        okText: "ยืนยัน", // "提交", // "Chắc Chắn",
        onOk: () => {
            // if (!localStorage.getItem('disable7819testcode')) {
            //     domainPath = 'https://p5stag7.fun88.biz/th'; // hard-code for testing purpose
            // }
            localStorage.setItem(TMP_CROSS_DOMAIN_LOGIN_TOKEN_KEY, crossDomainLoginToken);
            localStorage.setItem(TMP_CROSS_DOMAIN_LOGIN_PATH_KEY, domainPath);
            setTimeout(()=>{
                if (window.winForDomainSeg) {return;}
                showMessage('error', 'Please make sure your browser allow open new window ^', undefined, 5);
            }, 2000);
            window.winForDomainSeg = window.open(getPostMessageTargetPage(domainPath), '');
        },
    });
};

export const ifNeedHandle = (domainPath, accessToken) => {
    if (domainPath){
        openNewWindow(accessToken, domainPath);
        return true;
    }
    return false;
}